export default __webpack_public_path__ + "static/icon-17-5-6793016f532b180e58ba50b6046745b8.png";